import type { NgModuleRef } from '@angular/core';
import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import moment from 'moment-timezone';

import { AUTH_METHOD, AUTH_TOKEN, ENVIRONMENT } from '@core/common-legacy';
import { AuthorisationStrategy, AuthService, removeQueryParam } from '@core/http-legacy';
import { patchMoment } from '@core/i18n-legacy';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { bootstrapInjector } from './main-deps';

import './vendor';
import 'moment/locale/de';
import 'moment/locale/nl';
import 'moment/locale/fr';
import 'moment/locale/fi';
import 'moment/locale/sv';

// @ts-ignore
window['moment'] = moment;
patchMoment(moment);
moment.locale('en');

if (environment.angularProdMode) {
  enableProdMode();
}

const getAuthToken = async (): Promise<string | void> => {
  try {
    return await bootstrapInjector.get(AuthService).getAccessToken();
  } catch (err) {
    console.warn(`~~~~~~ getAccessToken ERROR ~~~~~~`);
    console.error(err);
  }
};

const bootstrap = async () => {
  const authToken = await getAuthToken();

  if (!authToken) {
    bootstrapInjector.get(AuthorisationStrategy).onAuthorizationFailed();
  }

  if (authToken) {
    bootstrapInjector.get(AuthService).saveAccessTokenInCookie(<string>authToken, false);
  }

  removeQueryParam('authorization_code');

  const ngModule: NgModuleRef<any> = await platformBrowserDynamic([
    { provide: AUTH_TOKEN, useValue: authToken },
    { provide: AUTH_METHOD, useValue: 'Bearer' },
    { provide: ENVIRONMENT, useValue: environment },
  ]).bootstrapModule(AppModule);

  return ngModule;
};

bootstrap();
